import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderCloud: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderCloud"><Path d="M2.5 12.5V3.5H10L12 6.5H21.5V19.5H11.5" stroke="currentColor" strokeLinecap="square"/><Path d="M4.25 15C5.32791 15 6.25898 15.6204 6.70996 16.5225C6.80485 16.5086 6.90156 16.5 7 16.5C8.10457 16.5 9 17.3954 9 18.5C9 19.6046 8.10457 20.5 7 20.5H4.25C2.73122 20.5 1.5 19.2688 1.5 17.75C1.5 16.2312 2.73122 15 4.25 15Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderCloud;
